export default {
  'tag': 't',
  'id': 'i',
  'class': 'c',
  ':nth-child': ':nc',
  ':nth-of-type': ':nt'
};



/** WEBPACK FOOTER **
 ** ./src/utils/attrCode.js
 **/